import { render } from "./DeleteAccount.vue?vue&type=template&id=82799642&scoped=true&ts=true"
import script from "./DeleteAccount.vue?vue&type=script&lang=ts"
export * from "./DeleteAccount.vue?vue&type=script&lang=ts"

import "./DeleteAccount.vue?vue&type=style&index=0&id=82799642&lang=less&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/mobile-mpe-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-82799642"]])

export default __exports__